import React from 'react';

import Header from '../components/Header';
import ContactContent from '../components/ContactContent';
import Footer from '../components/Footer';

export default function Contact() {
  return (
    <div className='container mt-2'>
      <Header />
      <ContactContent />
      <hr />
      <Footer />
    </div>
  );
}
